
<template>
  <div class="screen">
    <div class="ui container">
      <h1 class="ui header">Login</h1>

      <form class="ui form" v-on:submit.prevent="doLogin()">
          <div class="field">
              <label>StreamID</label>
              <input v-model="streamid" type="text" name="streamid" placeholder="Stream ID">
          </div>
          <div class="field">
              <label>Password</label>
              <input v-model="password" type="password" name="password" placeholder="Password">
          </div>
          <button class="ui button" type="submit" v-on:click.prevent="doLogin()">anmelden</button>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    data: function() {
      return {
        streamid: null,
        password: null
      }
    },

    methods: {
      doLogin() {
          this.$emit('do-login', this.streamid, this.password)
      },
    },

    created() {
      let urlParams = new URLSearchParams(window.location.search);
      if(urlParams.has('id'))
        this.streamid = urlParams.get('id');
    }
  }
</script>

<style scoped>
  .screen {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .screen div {
    width: 90vw;
    max-width: 30em;
  }
</style>